import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider } from '@mui/system'
import { Amplify } from 'aws-amplify'
import { awsConfig, globalStyles, theme } from 'config'
import { AuthProvider, SidebarProvider } from 'context'
import { MaintenanceProvider } from 'context/maintenance'
import { SnackbarProvider } from 'notistack'
import ReactGA from 'react-ga4'
import { AppRoutes } from 'routes'
import { DatadogErrorBoundary } from 'components/DatadogErrorBoundary'
import { useDatadogUser } from 'utils/hooks/useDatadogUser'

ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS}`)

Amplify.configure(awsConfig)

function DatadogUserTracker(): null {
  useDatadogUser()
  return null
}

function App(): JSX.Element {
  return (
    <div data-dd-privacy="allow">
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <SidebarProvider>
            <MaintenanceProvider>
              <SnackbarProvider
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
              >
                <GlobalStyles styles={globalStyles} />
                <DatadogErrorBoundary>
                  <DatadogUserTracker />
                  <AppRoutes />
                </DatadogErrorBoundary>
              </SnackbarProvider>
            </MaintenanceProvider>
          </SidebarProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  )
}

export default App
